export const experiences = [
  {
    id: 1,
    title: "Software Test Engineer",
    company: "OTOT Technologies",
    period: "Feb 2026 - Present",
    type: "work experience",
    description:
      "Perform manual functional, smoke, and regression testing in support of a Defense Health Agency (DHA) contract, operating within an Agile development framework with defect tracking and sprint management handled through Jira. Author test plans and test cases, and execute testing across online, offline, iOS, and Android environments to ensure consistent functionality across deployment scenarios. Collaborate cross-functionally with developers, project managers, and stakeholders throughout the testing lifecycle to surface defects early and support timely delivery.",
    tags: [
      "Software Testing",
      "Manual Testing",
      "Integration Testing",
      "Smoke Testing",
    ],
    // Tags marked true render highlighted (green border)
    highlights: ["Software Testing", "Manual Testing", "Jira"],
  },
  {
    id: 2,
    title: "Software QA Engineer",
    company: "Peraton",
    period: "Oct 2023 - May 2025",
    type: "work experience",
    description:
      "Conduct functional and integration testing of multiple programs within an IBM mainframe and client/server environments. Develop comprehensive test cases using IRS and contractor documentation to ensure program functionality and interface integrity. Review output results to validate compliance with established requirements, providing detailed feedback to programmers on identified errors and inconsistencies. Regression testing, Waterfall Methodology, Test Case Creation/Review, Identifying Defects and working with the development to resolve them.",
    tags: [
      "Software Testing",
      "Manual Testing",
      "Integration Testing",
      "Smoke Testing",
    ],
    // Tags marked true render highlighted (green border)
    highlights: ["Software Testing", "Automated Testing"],
  },
  {
    id: 3,
    title: "Freelance Software Developer",
    company: "Self-Employed",
    period: "May 2022 - Present",
    type: "work experience",
    description:
      "I build web applications with React and Node.js, and automate the workflows that off-the-shelf tools can't handle. My recent work includes two React/Node sites for family friends — a personal resume site and a farm business site currently being expanded into e-commerce — along with custom Python automation, including a booking system I built to handle appointments for my mother's interpretation service, which had no API to integrate with directly.",
    tags: ["Software Development", "Web Development", "Automation"],
    // Tags marked true render highlighted (green border)
    highlights: ["Software Development", "Web Development", "Automation"],
  },
  {
    id: 4,
    title: "Computer Science Degree",
    company: "Shippensburg University",
    period: "Jan 2018 - May 2022",
    type: "education",
    description:
      "Completed a Bachelor of Science in Computer Science with a focus on software engineering and web development. Gained proficiency in programming languages such as Python, Java, and JavaScript, and developed a strong foundation in algorithms, data structures, and database management.",
    tags: ["Computer Science", "Software Engineering", "Web Development"],
    highlights: ["Computer Science", "Software Engineering"],
  },
];
